import * as actionTypes from "./FlexiQuoteType";

const INITIAL_STATE = {
  flexiQuoteList: null,
  flexiQuoteListById: {},
  flexiQuoteStatus: [],
  flexiStatusCount: [],
  bpMasterAddress: [],
  flexiCategory: [],
  flexiItemListing: [],
  flexiSubItemListing: [],
  flexiPrice: [],
  taxCode: [],
  flexiAttachmentData: [],
  priceList: [],
  baseImage: "",
  salesEmployeeList: [],
  termsandCondition: [],
  FlexiFollowupHistory: []
};

const FlexiQuoteReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETFLEXIQUOTELIST:
      return {
        ...state,
        flexiQuoteList: action.payload,
      };
    case actionTypes.SETFLEXIQUOTELISTBYID:
      return {
        ...state,
        flexiQuoteListById: action.payload,
      };
    case actionTypes.SETFLEXIQUOTESTATUS:
      return {
        ...state,
        flexiQuoteStatus: action.payload,
      };
    case actionTypes.SETFLEXIQUOTESTATUSCOUNT:
      return {
        ...state,
        flexiStatusCount: action.payload,
      };
    case actionTypes.SETBPMASTERADDRESS:
      return {
        ...state,
        bpMasterAddress: action.payload,
      };
    case actionTypes.SETFLEXIQUOTECATEGORY:
      return {
        ...state,
        flexiCategory: action.payload,
      };
    case actionTypes.SETFLEXIQUOTEITEMLISTING:
      return {
        ...state,
        flexiItemListing: action.payload,
      };
    case actionTypes.SETFLEXIQUOTESUBITEMLISTING:
      return {
        ...state,
        flexiSubItemListing: action.payload,
      };
    case actionTypes.SETFLEXIQUOTEPRICE:
      return {
        ...state,
        flexiPrice: action.payload,
      };
    case actionTypes.SETTAXCODE:
      return {
        ...state,
        taxCode: action.payload,
      };
    case actionTypes.SETFLEXIATTACHMENTDATA:
      return {
        ...state,
        flexiAttachmentData: action.payload,
      };
    case actionTypes.SETPRICELIST:
      return {
        ...state,
        priceList: action.payload,
      };
    case actionTypes.SETBASEIMAGE:
      return {
        ...state,
        baseImage: action.payload,
      };
    case actionTypes.SETSALESEMPLOYEELIST:
      return {
        ...state,
        salesEmployeeList: action.payload,
      };
    case actionTypes.SETTERMSANDCONDITION:
      return {
        ...state,
        termsandCondition: action.payload,
      };
    case actionTypes.SETFLEXIFOLLWUPHISTORY:
      return {
        ...state,
        FlexiFollowupHistory: action.payload,
      };
    default:
      return state;
  }
};

export default FlexiQuoteReducer;
